import React from "react";

interface PolygonCircleWithNumberProps {
  color: string;
  numberToDisplay: number;
}

const PolygonCircleWithNumber = ({
    color,
    numberToDisplay,
}: PolygonCircleWithNumberProps) => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                height: 30,
                width: 30,
                backgroundColor: color,
                borderRadius: "50%",
            }}
        >
            <span style={{ color: "white", fontSize: 20 }}>{numberToDisplay}</span>
        </div>
    );
};

export default PolygonCircleWithNumber;
